import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
import { IMAGES } from '../data';
export function Hero() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);
  return <section ref={ref} id="top" className="relative flex min-h-screen w-full items-end overflow-hidden" data-id="element-118" data-mp="12a0l5b5wm0um">
      <motion.img style={{
      y
    }} src={IMAGES.heroEvening} alt="Dukat långbord i en småländsk trädgård i skymningsljus med levande ljus och gäster som skrattar" className="absolute inset-0 h-[120%] w-full object-cover origin-top" data-id="element-119" data-mp="xa4j3hgrojhp" />
      <div className="absolute inset-0 bg-gradient-to-t from-brun/80 via-brun/25 to-brun/40" data-id="element-120" data-mp="3d1ik78o21amw" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-16 md:px-10 md:pb-24" data-id="element-121" data-mp="382fern45x2ee">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-6 text-[12px] uppercase tracking-wide3 text-warm/70" data-id="element-122" data-mp="384s4wnk2qj2j">
          Handplockat i Småland
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1,
        ease: 'easeOut'
      }} className="font-display text-5xl font-light leading-[0.98] text-warm sm:text-6xl md:text-7xl lg:text-8xl" data-id="element-123" data-mp="39cpboqkkxd0s">
          Smaken som Baken
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25,
        ease: 'easeOut'
      }} className="mt-6 font-display text-xl italic text-warm/85 md:text-2xl" data-id="element-124" data-mp="2qkwjgydc3vu4">
          All mat. Alla smaker. Samlat i Småland.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.35,
        ease: 'easeOut'
      }} className="mt-7 max-w-xl text-base leading-relaxed text-warm/80 md:text-lg" data-id="element-125" data-mp="2ljz2gp4297u7">
          Smålands handplockade marknadsplats. Boka catering, fika och matupplevelser från regionens bästa hantverkare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.5,
        ease: 'easeOut'
      }} className="mt-10 flex flex-wrap gap-4" data-id="element-126" data-mp="db2ct9o7m5km">
          <a href="/utbud" className="group inline-flex items-center gap-3 rounded-full bg-warm px-9 py-4 text-sm uppercase tracking-wide2 text-brun transition-colors hover:bg-skog hover:text-warm" data-id="element-127" data-mp="112g5jgq9w364">
            Se utbudet
          </a>
          <a href="/bestall" className="group inline-flex items-center gap-3 rounded-full border border-warm/50 px-9 py-4 text-sm uppercase tracking-wide2 text-warm transition-colors hover:bg-warm hover:text-brun" data-id="element-128" data-mp="3lqui5yd6ip9t">
            Boka nu
          </a>
        </motion.div>
      </div>
    </section>;
}